<p-multiSelect
  [id]="fieldId"
  [options]="options"
  [formControl]="control"
  [filter]="true"
  [showToggleAll]="false"
  [emptyMessage]="options.length ? 'No results found' : 'No options yet'"
  defaultLabel="Select values"
  scrollHeight="124px">
  <ng-template pTemplate="footer">
    <div class="labels-add-custom" (click)="$event.stopPropagation()">
      <p-input-group>
        <input
          [id]="fieldId + 'CustomInput'"
          type="text"
          placeholder="Add value"
          [value]="customInput"
          (input)="onInputChange($any($event.target).value)"
          (keydown)="onKeyDown($event)"
          pInputText/>
        <p-inputgroup-addon>
          <button
            type="button"
            pButton
            label="Add"
            (click)="addCustomValue(); $event.stopPropagation()"
            [disabled]="!customInput || customInput.trim().length < 1">
          </button>
        </p-inputgroup-addon>
      </p-input-group>
    </div>
  </ng-template>
</p-multiSelect>
